import { clientSx } from '../theme';

/** Outlined section surface for patient form tabs (matches admin patient edit). */
export const FORM_SECTION_CARD_SX = clientSx.sectionCard;
